import { fileUpload } from "directus/src/operations";
import { queryClient } from "utils/react-query";
import { COLLECTION } from "../constants";

export function invalidateAllDeliverablesQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === COLLECTION,
  });
}

/** Uploads newly picked files and returns the ids of all files in the field. */
export async function uploadFiles(files = []) {
  const ids = [];
  for (const file of files) {
    if (file?.isNew && file.file) {
      const formData = new FormData();
      formData.append("file", file.file);
      const uploaded = await fileUpload(formData);
      ids.push(uploaded.id);
    } else if (file?.id) {
      ids.push(file.id);
    }
  }
  return ids;
}

/** Directus M2M payload for create: one junction row per related id. */
export function toJunctionRows(ids, junctionKey) {
  return ids.map((id) => ({ [junctionKey]: id }));
}

/**
 * Directus M2M change set for update: add newly selected ids and delete the
 * junction rows of deselected ones, so untouched rows are kept as-is.
 */
export function buildM2MChange(selectedIds, junctions, junctionKey) {
  const selected = new Set(selectedIds);
  const create = selectedIds
    .filter((id) => !junctions.has(id))
    .map((id) => ({ [junctionKey]: id }));
  const remove = [...junctions.entries()]
    .filter(([id]) => !selected.has(id))
    .map(([, junctionId]) => junctionId);
  if (!create.length && !remove.length) return undefined;
  return { create, update: [], delete: remove };
}
